import { ringCentroid } from '@/features/defect-drawer/utils/resolveModuleCoveringIrImages';

/**
 * siteDesign 모듈 피처 캐시 → seq별 링 [[lon, lat], ...]
 * @param {Array<{ get?: Function, getGeometry?: Function }>} features
 * @returns {Record<string, number[][]>}
 */
export function moduleRingsBySeqFromFeatures(features) {
  const rings = {};
  if (!Array.isArray(features)) {
    return rings;
  }
  for (const feature of features) {
    const seq = feature?.get?.('solar_module_seq');
    if (seq == null || seq === '') {
      continue;
    }
    const ring = feature.getGeometry?.()?.getCoordinates?.()?.[0];
    if (!Array.isArray(ring) || ring.length < 3) {
      continue;
    }
    rings[String(seq)] = ring;
  }
  return rings;
}

/**
 * siteDesign 모듈 피처 캐시 → seq별 중심점 [lon, lat]
 * @param {Array<{ get?: Function, getGeometry?: Function }>} features
 * @returns {Record<string, [number, number]>}
 */
export function moduleCentersBySeqFromFeatures(features) {
  const centers = {};
  const rings = moduleRingsBySeqFromFeatures(features);
  for (const [seq, ring] of Object.entries(rings)) {
    const center = ringCentroid(ring);
    if (!center) {
      continue;
    }
    centers[seq] = center;
  }
  return centers;
}
